import * as App from "@timesheets/routes-app";

import { RouteConfig } from "vue-router";
import { Timesheet } from "@timesheets/constants-common";

export const timesheets: RouteConfig[] = [
  {
    path: App.Timesheets.Root,
    name: Timesheet.Behaviour.CollectionName,
    component: async () => import("Dashboard/components/Timesheets/TimesheetsMenuList.vue"),
  },
  {
    path: App.Timesheets.ById,
    name: Timesheet.Behaviour.ItemName,
    component: async () => import("Dashboard/components/Timesheets/Detail/Index.vue"),
  },
];
